module.exports = __webpack_public_path__ + "static/12-0b2b8c04c0a8112f7d0729bacd50f7ef.jpg";